import { ConfigUpdateError } from '../../store/integration-config/integration-configs.slice'

type SaveStatus = { type: 'error'; message: string }

interface FormikErrorHelpers {
  setStatus: (status: SaveStatus) => void
  setFieldError: (field: string, message: string) => void
  setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void
}

function isConfigUpdateError(error: unknown): error is ConfigUpdateError {
  return typeof error === 'object' && error !== null && typeof (error as ConfigUpdateError).message === 'string'
}

/**
 * Applies a server error thrown by the updateIntegrationConfig thunk (via
 * `.unwrap()`) to a Formik form: field-targeted errors highlight the relevant
 * input, and every error is shown in the general error banner.
 */
export function applyConfigUpdateError(error: unknown, helpers: FormikErrorHelpers): void {
  const { message, field } = isConfigUpdateError(error) ? error : { message: 'Failed to save. Please try again.', field: undefined }

  if (field) {
    // Fields gate their helperText on `touched && errors`, so mark it touched.
    helpers.setFieldTouched(field, true, false)
    helpers.setFieldError(field, message)
  }
  helpers.setStatus({ type: 'error', message })
}
